'use strict';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var Popup = /*#__PURE__*/function () {
  function Popup(button) {
    var _this = this;

    var popup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '.popup';

    _classCallCheck(this, Popup);

    this.active = 'popup--active';
    this.body = document.querySelector('body');
    this.button = button;
    this.buttonId = button.dataset.popuptrigger;
    this.fullWidth = 'popup--full-width';
    this.popup = document.querySelector("".concat(popup, "[data-popup=").concat(this.buttonId, "]"));
    this.popupContent = this.popup.querySelector('.popup__content');
    this.closeButton = this.popup.querySelector('.popup__close-button');
    this.button.addEventListener('click', function (e) {
      e.preventDefault();

      _this.toggle();
    });

    if (this.closeButton) {
      this.closeButton.addEventListener('click', function () {
        _this.hide();
      });
    }

    window.addEventListener('click', function (e) {
      if (e.target !== _this.button && !_this.popup.contains(e.target) && !_this.button.contains(e.target)) {
        if (_this.isActive()) {
          _this.hide();
        }
      }
    });
  }

  _createClass(Popup, [{
    key: "toggle",
    value: function toggle() {
      if (this.isActive()) {
        this.hide();
      } else {
        this.show();
      }
    }
  }, {
    key: "show",
    value: function show() {
      this.popup.classList.add(this.active);
      this.popup.open = true;
      this.popupContent.focus();
      window.addEventListener('keydown', this.keyboardClosePopup.bind(this));
    }
  }, {
    key: "hide",
    value: function hide() {
      this.popup.classList.remove(this.active);
      this.button.focus();
      this.popup.open = false;
    }
  }, {
    key: "isActive",
    value: function isActive() {
      return this.popup.classList.contains(this.active);
    }
  }, {
    key: "keyboardClosePopup",
    value: function keyboardClosePopup(event) {
      if (event.which === 27) {
        if (this.isActive()) {
          event.preventDefault();
          this.hide();
        }
      }
    }
  }]);

  return Popup;
}();

define(function () {
  return function (config, element) {
    new Popup(element);
  };
});
//# sourceMappingURL=popup.babel.js.map
